<template>
    <div class="editable-choice">
        <editable :value.sync="value"
                  :display-value="displayValue"
                  :placeholder="placeholder">
            <div slot="editor">
                <v-select :value.sync="editValue"
                          :placeholder="placeholder"
                          :options="options"></v-select>
                <a class="btn btn-link btn-sm"
                   v-on:click.prevent="reset()"
                   v-if="editValue && enableReset">
                    RÀZ
                </a>
            </div>
        </editable>
    </div>
</template>

<style scoped
       lang="less">
    @import '~src/style/variables';

    .editable-choice {
        display: inline-block;
        background-color: #ccc;
    }

    .editing {
        display: inline-flex;
        align-items: center;

        .btn-group {
            margin-left: 5px;
        }
    }

    .placeholder {
        font-style: italic;
        color: lighten(@text-color, 20%);
    }
</style>

<script type="text/ecmascript-6">
    import VSelect from 'vue-strap/src/Select';
    import Editable from './Editable';

    export default {
        components: {
            VSelect,
            Editable
        },
        props: {
            placeholder: {
                'default': 'Choisir...'
            },
            value: {
                twoWay: true,
                'default': ''
            },
            options: {
                type: Array
            },
            enableReset: {
                'default': false
            }
        },
        computed: {
            optionsMap() {
                const out = {};

                if (!this.options || !(this.options instanceof Array)) {
                    return out;
                }

                for (const {value, label} of this.options) {
                    out[value] = label;
                }

                return out;
            },
            displayValue() {
                return this.optionsMap[this.value];
            }
        },
        data() {
            return {
                editValue: '',
                editing: false,
                editable: true
            };
        },
        methods: {
            reset() {
                this.editValue = '';
            }
        },
        events: {
            'editable:childStartEdition': function () {
                this.editValue = this.value || '';
            },
            'editable:childValidateEdition': function () {
                this.value = this.editValue[0];
            }
        }
    };
</script>



// WEBPACK FOOTER //
// EditableChoice.vue?678b127c